export default __webpack_public_path__ + "static/media/02.aa37f0c0.mtl";